import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
	progresso: { type: Number, required: true, default: 0 },
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

})